// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import moment from 'moment';
import Dialog from 'material-ui/Dialog';
import DatePicker from 'react-datepicker';


class AddCompetitionGallery extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      competition_id:props.competition_id,
      venues:[],
      game_types:[],
      sub_categories:[],
      data_uploaded: false,
      data_error: false,
      addGalleryView:false,
      gallery_details:{
            competition_id:props.competition_id,
            name :'',
            description :'',
            cover_photo :'',
            fb_album_id :'',
            fb_album_url :'',
            venue : '',
            sub_category:'',
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getGalleryDetail = this.getGalleryDetail.bind(this);
  }

  componentDidMount() {
    this.getGalleryDetail();
    console.log(this.state);
  }
  getGalleryDetail() {
        const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_competition_gallery/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'competition_id': this.state.competition_id
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({venues: data.venues,game_types: data.game_types,sub_categories: data.sub_categories, search: true}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
  }

  
  postaddGallery(data, props) {
    console.log(data);
    if(!data.sub_category){data.sub_category = this.state.sub_categories[0][0]}
    if(!data.venue){data.venue = this.state.venues[0].id}
    console.log(data)
    const url = `${getLocationOrigin()}/tournament/add_competition_gallery/`;
    const options = {...defaultOptions};
    var formData = new FormData();
    for(var name in data) {
      formData.append(name, data[name]);
    }
    options['method'] = 'post';
    options['body'] = formData;
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((response) =>{                      // first then()
          alert(response.message);
          this.setState({addGalleryView:false})
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
    
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.gallery_details);
    new_selected_one[name] = event.target.value
    this.setState({gallery_details: new_selected_one});
  }

  handleSubmit(event) {
    event.preventDefault();
    this.postaddGallery(this.state.gallery_details, this.props);
    console.log('post');
    console.log(this.state);
  }
  toAddGallery(){
    this.setState({addGalleryView:!this.state.addGalleryView})
  }

  
  render() {
    console.log(this.state)
    return(
      <div className="col-md-12">
        {!this.state.addGalleryView &&
        <div className="col-md-12" style={{padding:'22px','textAlign':"left"}} >
            <input className="button1" type="button" value="Add Album" onClick={() => {this.toAddGallery()}} />
        </div>
        }
        {this.state.addGalleryView &&
        <div className="col-md-12 " style={styles.container}>
        <div className="col-md-8 table_container1" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Add Competition Gallery </h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Name *
              </div>
              <div className="col-md-6 input-group">
                <input type="text" style={styles.input} name="name" className="required"
                  value={this.state.value} onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Description 
              </div>
              <div className="col-md-6 input-group">
                <input type="text" style={styles.input} name="description" className="required"
                  value={this.state.value} onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venue
              </div>
              <div className="col-md-6 input-group" >
                <select name="venue"  style={styles.item_body} value={this.state.value}
                      onChange={this.handleChange}>
                      {
                        this.state.venues.map((x, index) => (
                        <option key={x.id} value={x.id}>{x.name}</option>
                        ))
                      }
                    </select>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Sub Category
              </div>
              <div className="col-md-6 input-group">
                <select name="sub_category"  style={styles.item_body} value={this.state.value}
                      onChange={this.handleChange}>
                      {
                        this.state.sub_categories.map((x, index) => (
                        <option key={x[0]} value={x[0]}>{x[1]}</option>
                        ))
                      }
                    </select>
              </div>
            </div>
            <div className="col-md-12" style={{paddingLeft:'10%',paddingRight:'10%'}} >
                <div style={{backgroundColor:'#FFFAB5',textAlign:'center',fontSize:'20px'}}>
                  URL should be an Image Url 
                </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                 Cover Photo Url
              </div>
              <div className="col-md-6 input-group">
                <input type="text" style={styles.input} name="cover_photo" className="required"
                  value={this.state.value} onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                FB Album Id
              </div>
              <div className="col-md-6 input-group">
                <input type="text" style={styles.input} name="fb_album_id" className="required"
                  value={this.state.value} onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                FB Album Url 
              </div>
              <div className="col-md-6 input-group">
                <input type="text" style={styles.input} name="fb_album_url" className="required"
                  value={this.state.value} onChange={this.handleChange}/>
              </div>
            </div>
            
            <div style={styles.button_submit} className="col-md-12">
              <input className="button1" type="submit" value="Submit" />
              <input className="button1" type="button" value="Cancel" style={{backgroundColor:'red',color:'#ffffff',marginLeft:'20px'}} onClick={() => {this.toAddGallery()}} />
            </div>
          </form>
        </div>
        </div>
       
        }
      </div>
    );
  }
}

export default AddCompetitionGallery;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addCompetitionGallery/index.js